export default __webpack_public_path__ + "static/worksans-semibolditalic-webfont-0b11e711be0e62b698ec1178ac45b0cd.woff2";